export default __webpack_public_path__ + "static/media/Shark_Animated.cffe888d.glb";